/*©**********************************************************************************
*                                                                                   *
* SPDX-License-Identifier: AGPL-3.0-or-later                                        *
*                                                                                   *
* This program is licensed under the GNU Affero General Public License v3+.         *
* See the LICENSE file or <https://www.gnu.org/licenses/agpl-3.0.html> for details. *
*                                                                                   *
**********************************************************************************©*/

import React, { useEffect } from 'react';
import AppRouter from './AppRouter';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { NotificationProvider } from './context/NotificationContext';
import { DevModeProvider } from './context/DevModeContext';
import { PlatformConfigProvider } from './context/PlatformConfigContext';
import useColorMode from './hooks/useColorMode';
import { getAppName } from './config/app';
import '@mantine/notifications/styles.css';

function App() {
  // Initialize dark mode on app start
  useColorMode();

  useEffect(() => {
    const appName = getAppName();
    document.title = appName;

    const descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) {
      descriptionTag.setAttribute('content', `${appName} - Automated Trading Platform`);
    }
  }, []);

  return (
    <MantineProvider>
      <Notifications position="top-right" />
      <NotificationProvider>
        <DevModeProvider>
          <PlatformConfigProvider>
            <AppRouter />
          </PlatformConfigProvider>
        </DevModeProvider>
      </NotificationProvider>
    </MantineProvider>
  );
}

export default App;
